

const VerseRow = ({ verse }) => {
  if (!verse) return null;

  return (
    <div className="flex flex-col">
      <p className="text-white text-sm">
        {verse.book_name} {verse.chapter}:{verse.verse_start}
      </p>
      <p className="text-xs text-gray-400 line-clamp-2">
        {verse.verse_text}
      </p>
    </div>
  );
};

export default VerseRow;
